import { render, staticRenderFns } from "./AmbitusInfo.vue?vue&type=template&id=20c882d4&scoped=true&xmlns=http%3A%2F%2Fwww.w3.org%2F1999%2Fhtml&"
import script from "./AmbitusInfo.vue?vue&type=script&lang=js&"
export * from "./AmbitusInfo.vue?vue&type=script&lang=js&"
import style0 from "./AmbitusInfo.vue?vue&type=style&index=0&id=20c882d4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20c882d4",
  null
  
)

export default component.exports